const formatLinks = (
  links: ProductNavigationLinks,
  rootModuleName?: string
): SiteAreaNavLinks => links.map(({
  tenant,
  url,
  path = '',
  children,
  ...rest
}) => ({
  ...rest,
  // use relative path when in the same tenancy
  url: tenant === rootModuleName ? path : url,
  route: tenant === rootModuleName,
  // recurse upon children if they exist
  ...children ? {
    children: formatLinks(children, rootModuleName),
  } : {},
}));

export default formatLinks;
